/**
 * Created by Ivan on 21.08.2025
 */

RewardsConfig.WeeklyGoal = {
    easy: [{ hard: 20 }],
    medium: [{ hard: 30 }],
    hard: [{ hard: 40 }],
    completeAll: [{ hard: 50 }]
};

if (cleverapps.config.type === "merge") {
    RewardsConfig.WeeklyGoalPointsRewards = [
        { units: { code: "energycup", stage: 0 } },
        { units: { code: "crystal", stage: 3 } },
        { units: { code: "energycup", stage: 1 } },
        { units: { code: "herochest", stage: 2 } },
        { units: [{ type: "reschest", stage: 1 }, { code: "herochest", stage: 2 }, { code: "sacks", stage: 2 }, { code: "treasure", stage: 2 }] }
    ];
} else if (cleverapps.config.type === "merge2") {
    RewardsConfig.WeeklyGoalPointsRewards = [
        { energy: 50 },
        { units: { code: "ff", stage: 2 } },
        { energy: 100 },
        { units: { code: "Ai", stage: 2 } },
        { units: [{ code: "rr", stage: 3 }, { code: "ff", stage: 7 }], energy: 200, stickers2RedPack: 1 }
    ];
} else {
    RewardsConfig.WeeklyGoalPointsRewards = [
        { boosters: { before_cheap: 1 } },
        { boosters: { cheap: 1 } },
        { boosters: { before_medium: 1 }, stickers2BluePack: 1 },
        { boosters: { medium: 1 } },
        { boosters: { cheap: 1, medium: 1, expensive: 1 }, unlimitedLives: "60 minutes", stickers2RedPack: 1 }
    ];
}
